import React from 'react';
import {Link} from 'react-router';
import moment from 'moment';
import Rating from '../rating/rating';
import MediaQuery from 'react-responsive';
import './user_review_thread.less';

export default class UserReviewThread extends React.Component {
    constructor(props){
        super(props);
    }


    render(){
        const {props, state} = this;
        // let reviewDate = moment.unix(props.reviewObj.reviewDate/1000).format("MMM YYYY");
        let reviewDate = moment(props.reviewObj.reviewDate).format('ll');
        let userProfileImage = props.reviewObj.profileImgUrl || "../../public/images/user_placeholder.svg";
        let url = '/user-profile/' + props.reviewObj.reviewedBy;
        let backTo;
        (props.backTo) ? (backTo = props.backTo, url = url + '?backTo=' + backTo) : (backTo = null);


        return(
          <Link to={url}>
            <div className="review-details-wrap">
                <div className="reviewer-profile-img-wrap">
                    <img className="reviewer-profile-img" src={userProfileImage} />
                </div>
                <div className="review-details">
                    <div className="reviewer-name">
                      <span className="reviewer-name-elm">{props.reviewObj.name}</span>
                      {props.reviewObj.isVerified && <span className="verified-img"></span>}
                    </div>
                    <div className="reviewer-rating">
                        <Rating rating={props.reviewObj.rating} ratingSize="rating-size14" />
                    </div>
                    <div className="reviewer-review">{props.reviewObj.comments}</div>
                </div>
                  <div className="review-date">{reviewDate}</div>

            </div>
          </Link>
        )
    }
}

UserReviewThread.propTypes = {
    reviewObj: React.PropTypes.object.isRequired,
    backTo: React.PropTypes.string
}



// WEBPACK FOOTER //
// app/components/user_review_thread/user_review_thread.jsx